<template>
	<div class="discount">
		<el-tabs v-model="active" @tab-click="handleClick">
			<el-tab-pane label="进货折扣列表" name="list"></el-tab-pane>
			<el-tab-pane label="无进货折扣列表" name="nolist">
				<span slot="label">无进货折扣列表(<i class="i1">{{nototal}}</i>)</span>
			</el-tab-pane>
		</el-tabs>

		<el-dialog title="进货折扣导入" :visible.sync="uploadVisible" width="600px" :before-close="onclose2">
			<!-- <div class="uploadboxs" v-if="uploadVisible">
				<div class="uploadbox">
					<p>第一步，点击下载模版</p>
					<el-button type="success" size="small" @click="ondownload">下载模版</el-button>
				</div>
				<div class="uploadbox">
					<p>第二步，点击上传模版</p>
					<myupload @resultUrl="onreturnUrl" :uptype="2"></myupload>
					<div class="filenames" v-if="uploaddata.file_name">
						<div class="filename">
							<span>{{uploaddata.file_name}}</span>
							<i class="el-icon-success"></i>
						</div>
					</div>
				</div>
			</div> -->
			<div class="uploaddiv">
				<div class="i_b">
					<el-input v-model="uploadtext" placeholder="请上传文件" size="small" :readonly="true"></el-input>
					<myupload @resultUrl="onreturnUrl" :uptype="2"></myupload>
				</div>
				<div class="a" @click="ondownload">下载模版</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose2">取消</el-button>
				<el-button type="primary" @click="onfile()">确定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="设置折扣" :visible.sync="dialogVisible" width="85%" :before-close="onclose">
			<div class="ftop">
				<div class="imgform">
					<div class="img">
						<img :src="onimgarr(checkdata.product_pic)[0]">
					</div>
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm" v-if="dialogVisible" label-position="left">
						<el-form-item label="进货折扣设置" prop="discount">
							<el-input v-model="ruleForm.discount" style="width: 180px" placeholder="请输入折扣值" @keyup.enter.native="onsub()"></el-input>
						</el-form-item>
					</el-form>
					<div class="sync-channels" v-if="availableChannels.length > 0">
						<el-checkbox v-model="syncChannels">同时更新到其他目标渠道:</el-checkbox>
						<el-checkbox-group v-model="syncChannelIds" v-if="syncChannels" class="sync-channel-list">
							<el-checkbox
								v-for="ch in availableChannels"
								:key="ch.shop_id"
								:label="ch.shop_id"
							>
								{{ ch.shop_name }}
								<span class="ch-discount">（当前{{ ch.current_discount }}折）</span>
							</el-checkbox>
						</el-checkbox-group>
						<div class="sync-tip-line" v-if="syncChannels">
							<span class="sync-tip">（目标渠道，可以多选）</span>
						</div>
					</div>
				</div>
				<div>
					<el-button type="primary" @click="onsub()">确定</el-button>
				</div>

			</div>

			<div class="ftitle">
				<div>渠道:<span>{{checkdata.shop_name}}</span></div>
				<div>品牌:<span>{{checkdata.product_brand}}</span></div>
				<div>款号:<span>{{checkdata.product_style_number}}</span></div>
				<div>吊牌价:<span>{{checkdata.product_price}}</span></div>
				<div>大类:<span>{{checkdata.product_cid_first}}</span></div>
				<div>中类:<span>{{checkdata.product_cid_second}}</span></div>
				<div>小类:<span>{{checkdata.product_cid_third}}</span></div>
				<div>性别:<span>{{checkdata.product_sex}}</span></div>
				<div>系列:<span>{{checkdata.product_series}}</span></div>
				<div>颜色:<span>{{checkdata.product_color}}</span></div>
				<div>季度:<span>{{checkdata.product_season}}</span></div>
				<div>库存:<span>{{checkdata.stock}}</span></div>
			</div>

			<div class="ftable">
				<el-table :data="pricelist" style="width: 100%" border :cell-class-name="cellClassName">
					<el-table-column label="渠道" fixed="left" align="center" header-align="center" min-width="90px">
						<template slot-scope="scope">
							<div>{{scope.row.shop_name}}</div>
							<div class="is">
								<el-tooltip :content="scope.row.shop_qq" placement="bottom" effect="light">
									<img src="../../assets/image/qq.png" @click="oncopy(scope.row.shop_qq)">
								</el-tooltip>
								<el-popover width="401" placement="right" trigger="click"
									@show="ongdd(scope.row.shop_id)" @hide="onhide">
									<div class="ggbox">
										<el-table :data="glist" style="width: 100%" height="calc(100% - 52px)" border>
											<el-table-column width="240" label="标题" align="left"
												header-align="center">
												<template slot-scope="scope1">
													<div class="ggt" @click="oncontent(scope1.row.id,scope.row.shop_id)">{{scope1.row.name}}</div>
												</template>
											</el-table-column>
											<el-table-column width="160" prop="create_time_str" label="日期"
												align="center" header-align="center"></el-table-column>
										</el-table>
										<div class="pagediv">
											<el-pagination background layout="prev, pager, next, total" :page-sizes="[20, 30, 50, 100, 200]"
												:current-page.sync="page2" :page-size="pageSize2" :total="total2" v-if="total2 > 0"
												@current-change="handleCurrentChange2(scope.row.shop_id)" @size-change="handleSizeChange2($event,scope.row.shop_id)">
											</el-pagination>
										</div>
									</div>
									<i slot="reference" class="el-icon-chat-line-round"></i>
								</el-popover>
							</div>
						</template>
					</el-table-column>
					<el-table-column :prop="onprop(x)" v-for="(x,y) in pricesize" :key="y" min-width="50px"
						align="center" header-align="center">
						<template slot="header" slot-scope="scope">
							<div>{{x.size}}</div>
							<div>{{x.size_ch}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="stock" label="合计" align="center" header-align="center" min-width="60px">
					</el-table-column>
					<el-table-column prop="agent_price" label="代理价" align="center" header-align="center"
						min-width="70px">
					</el-table-column>
					<el-table-column prop="true_discount" label="折扣" align="center" header-align="center"
						min-width="60px">
					</el-table-column>
					<el-table-column prop="stop_take_time" label="下单截止时间" align="center" header-align="center"
						min-width="90px">
					</el-table-column>
					<el-table-column prop="allocation_rate" label="实际配货率" align="center" header-align="center"
						min-width="70px">
					</el-table-column>
					<el-table-column prop="free_return_rate" label="免费退货比例+超出扣额" align="center" header-align="center"
						min-width="110px">
					</el-table-column>
					<el-table-column prop="on_time_rate" label="发货准时率" align="center" header-align="center"
						min-width="70px">
					</el-table-column>
					<el-table-column prop="avg_scale" label="平均运费" align="center" header-align="center"
						min-width="80px">
					</el-table-column>
					<el-table-column label="多仓发货" align="center" header-align="center" min-width="70px">
						<template slot-scope="scope">
							<img class="simg" src="../../assets/image/dancang.jpg" :title="alt"
								v-if="scope.row.shop_multi_delivery_switch == 0">
							<img class="simg" src="../../assets/image/duocang.jpg" :title="alt"
								v-if="scope.row.shop_multi_delivery_switch == 1">
							<div>{{onsecurity(scope.row.security)}}</div>
						</template>
					</el-table-column>
				</el-table>

				<div class="pagediv">
					<el-pagination background layout="prev, pager, next, total" :current-page.sync="page1"
						:page-size="pageSize1" :total="total1" v-if="total1 > 0" @current-change="handleCurrentChange1">
					</el-pagination>
				</div>
			</div>
		</el-dialog>

		<el-dialog title="批量设置撕防伪" :visible.sync="securityVisible" width="60%" :before-close="onclose3">
			<el-form :model="securityForm" :rules="rules" ref="securityForm" label-width="120px" class="demo-ruleForm"
				v-if="securityVisible">
				<el-form-item label="已选择">
					<div>{{selectionArr.length}}条数据</div>
				</el-form-item>
				<el-form-item label="设置撕防伪" prop="security">
					<el-select v-model="securityForm.security" placeholder="撕防伪">
						<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.discount_security"
							:key="k">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose3">取消</el-button>
				<el-button type="primary" @click="onsubsecurity()">确定</el-button>
			</div>
		</el-dialog>

		<div class="btnbox">
			<el-button type="primary" size="small" @click="onuploadbox()">折扣导入</el-button>
			<el-button type="primary" size="small" v-if="active == 'list'" @click="onexport(1)">折扣导出</el-button>
			<el-button type="primary" size="small" v-if="active == 'list'" @click="ondelete('',2)">删除折扣</el-button>
			<el-button type="primary" size="small" v-if="active == 'list'" @click="onadd()">新增折扣</el-button>
			<el-button type="primary" size="small" v-if="active == 'list' && formfilter.shop_id" @click="ondelshopAll()">当前渠道折扣全部删除</el-button>
			<el-button type="primary" size="small" v-if="active == 'nolist'" @click="onexport(2)">无进货折扣导出</el-button>
			<el-button type="primary" size="small" @click="onallclear">清空库存</el-button>
			<el-button type="primary" size="small" v-if="active == 'list'" @click="onallsecurity">批量设置撕防伪</el-button>
		</div>

		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width=""
					v-if="filtershow">
					<el-form-item label="">
						<el-select v-model="formfilter.shop_id" placeholder="渠道">
							<el-option label="渠道" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in qudao" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.brand" placeholder="品牌"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="formfilter.cid" placeholder="商品大类">
							<el-option label="商品大类" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.product_cid" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.season" placeholder="季度"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.style_number" placeholder="款号"></el-input>
					</el-form-item>
					<el-form-item label="" v-if="active == 'list'">
						<el-select v-model="formfilter.security" placeholder="撕防伪">
							<el-option label="是否设置撕防伪" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.discount_security"
								:key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
				<div class="p" v-if="filtershow && p">
					渠道统计: 
					有库存总款号数量<span>{{p.total_style_num}}</span>
					总库存数量<span>{{p.total_stock_num}}</span>
					总吊牌金额<span>{{p.total_price}}</span>
					总折扣金额<span>{{p.total_discount_price}}</span>
					两周总销量<span>{{p.total_buy_number_2week}}</span>
				</div>
			</div>

			<div class="zk" @click="filtershow=!filtershow ">
				<span>{{filtershow ? '收起':'展开'}}</span>
			</div>

			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border @selection-change="handleSelectionChange"
					v-if="active == 'list'" height="100%">
					<el-table-column type="selection" width="50" fixed="left" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="shop_name" label="渠道" fixed="left" align="center" header-align="center"
						min-width="90px">
					</el-table-column>
					<el-table-column prop="product_brand" label="品牌" align="center" header-align="center"
						min-width="90px">
					</el-table-column>
					<el-table-column prop="product_season" label="季度" align="center" header-align="center"
						min-width="70px">
					</el-table-column>
					<el-table-column prop="product_style_number" label="款号" align="center" header-align="center"
						min-width="90px">
					</el-table-column>
					<el-table-column label="图片" width="120px" align="center" header-align="center">
						<template slot-scope="scope">
							<div class="img">
								<img :src="onimgarr(scope.row.product_pic)[0]">
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="discount" label="折扣" align="center" header-align="center" width="50px">
					</el-table-column>
					<el-table-column prop="true_discount" label="供货折扣" align="center" header-align="center"
						width="60px">
					</el-table-column>
					<el-table-column prop="product_price" label="吊牌价格" align="center" header-align="center"
						min-width="60px">
					</el-table-column>
					<el-table-column prop="platform_buy_number_2week" label="平台月销售数" align="center"
						header-align="center" min-width="70px">
					</el-table-column>
					<el-table-column prop="buy_number_2week" label="月销售数" align="center" header-align="center"
						min-width="50px">
					</el-table-column>
					<el-table-column prop="buy_number" label="合计销售数" align="center" header-align="center"
						min-width="70px">
					</el-table-column>
					<el-table-column prop="stock" label="库存" align="center" header-align="center" min-width="50px">
					</el-table-column>
					<el-table-column prop="secruity_str" label="撕防伪" align="center" header-align="center"
						min-width="70px">
					</el-table-column>
					<el-table-column label="操作" header-align="center" width="160px" align="center" fixed="right">
						<template slot-scope="scope">
							<div class="operation_i">
								<span @click="onmodify(scope.row)">设置折扣</span>
								<span @click="ondelete(scope.row.id,1)">删除折扣</span>
							</div>
						</template>
					</el-table-column>
				</el-table>

				<el-table :data="nolist" style="width: 100%" border @selection-change="handleSelectionChange"
					v-if="active == 'nolist'" height="100%">
					<el-table-column type="selection" width="50" align="center" header-align="center" fixed="left">
					</el-table-column>
					<el-table-column prop="shop_name" label="渠道" align="center" header-align="center" min-width="80px"
						fixed="left">
					</el-table-column>
					<el-table-column prop="product_brand" label="品牌" align="center" header-align="center"
						min-width="80px">
					</el-table-column>
					<el-table-column prop="product_season" label="季度" align="center" header-align="center"
						min-width="80px">
					</el-table-column>
					<el-table-column prop="product_style_number" label="款号" align="center" header-align="center"
						min-width="90px">
					</el-table-column>
					<el-table-column prop="product_cid_first" label="大类" align="center" header-align="center"
						min-width="80px">
					</el-table-column>
					<el-table-column prop="product_cid_second" label="中类" align="center" header-align="center"
						min-width="80px">
					</el-table-column>
					<el-table-column prop="product_cid_third" label="小类" align="center" header-align="center"
						min-width="80px">
					</el-table-column>
					<el-table-column prop="product_series" label="系列" align="center" header-align="center"
						min-width="80px">
					</el-table-column>
					<el-table-column prop="product_sex" label="性别" align="center" header-align="center"
						min-width="50px">
					</el-table-column>
					<el-table-column prop="product_color" label="颜色" align="center" header-align="center"
						min-width="50px">
					</el-table-column>
					<el-table-column prop="product_price" label="吊牌价格" align="center" header-align="center"
						min-width="60px">
					</el-table-column>
					<el-table-column prop="stock" label="库存" align="center" header-align="center" min-width="60px">
					</el-table-column>
					<el-table-column label="操作" header-align="center" width="90px" align="center" fixed="right">
						<template slot-scope="scope">
							<div class="operation_i">
								<span @click="onmodify(scope.row)">设置折扣</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pagediv">
			<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 50, 100, 200]" :current-page.sync="page" :page-size="pageSize"
				:total="total" v-if="total > 0" @current-change="handleCurrentChange" @size-change="handleSizeChange">
			</el-pagination>
		</div>
		
		<el-dialog title="渠道公告" :visible.sync="show" width="60%" :before-close="onclose4">
			<div class="notice" v-if="show">
				<div class="h1">{{checkobj.name}}</div>
				<div class="time">{{checkobj.create_time_str}}</div>
				<div class="ql-editor" v-html="checkobj.content"></div>
				<div class="myjg">温馨提示：任何脱离本平台的资金交易行为，均与本公司无任何关联，本公司不承担相关责任，请您谨慎操作，谨防风险。</div>
			</div>
		</el-dialog>
		
		<el-dialog title="新增折扣" :visible.sync="show1" width="600px" :before-close="onclose5">
			<el-form :model="addForm" :rules="rules" ref="addForm" label-width="100px" class="demo-ruleForm" v-if="show1">
				<el-form-item label="渠道" prop="shop_id" class="fitem">
					<el-select v-model="addForm.shop_id" placeholder="请选择渠道">
						<el-option :label="v.name" :value="v.id" v-for="(v,k) in qudao" :key="k">
						</el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item label="款号" prop="style_number" class="fitem">
					<el-input v-model="addForm.style_number" placeholder="请输入款号"></el-input>
				</el-form-item>
				
				<el-form-item label="折扣设置" prop="discount" class="fitem">
					<el-input v-model="addForm.discount" placeholder="请输入折扣值"></el-input>
				</el-form-item>
				
			</el-form>
			
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose5">取消</el-button>
				<el-button type="primary" @click="onsubadd()">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'discount',
		data() {
			return {
				active: 'list',

				formfilter: {
					shop_id: "",
					brand: "",
					cid: "",
					season: "",
					style_number: "",
					security: ""
				},
				qudao: [],

				filtershow: true,

				list: [],
				nolist: [],
				nototal: 0,
				selectionArr: [],

				page: 1,
				pageSize: 20,
				total: 0,

				uploadVisible: false,
				uploaddata: {
					file_name: "",
					path: ""
				},

				pricelist: [],
				pricesize: [],
				dialogVisible: false,
				checkdata: {},
				page1: 1,
				pageSize1: 10,
				total1: 0,
				ruleForm: {
					discount: ""
				},
				syncChannels: false,
				syncChannelIds: [],
				availableChannels: [],
				rules: {
					discount: [{
						required: true,
						message: '请设置折扣'
					}, {
						pattern: /^\d+(\.\d{1,2})?$/,
						message: '格式不正确，请输入最多两位小数的数字',
						trigger: 'blur'
					}],

					security: [{
						required: true,
						message: '请选择一个状态',
						trigger: 'change'
					}],
					
					shop_id: [{
						required: true,
						message: '请选择渠道',
						trigger: 'change'
					}],
					
					style_number: [{
						required: true,
						message: '请输入款号',
						trigger: 'blur'
					}]
				},

				securityVisible: false,
				securityForm: {
					security: ""
				},

				glist: [],
				page2: 1,
				pageSize2: 20,
				total2: 0,
				checkobj: {},
				show: false,
				uploadtext: "",
				show1: false,
				addForm: {
					shop_id: "",
					style_number: "",
					discount: ""
				},
				p: {},
				alt: "选择省份，显示该省份的实际运费标准,“单”表示本渠道单仓发货；“多”表示多仓发货，多件的订单可能分多仓发货，尤其是需要发顺丰到付的！“按件”表示渠道的运费计算方式（因多仓发货，按件收费，若下多件，第1件，按首重付费，第2件开始按续重收费），请注意！"
			}
		},

		inject: ['appdata', 'onimgarr', 'oncopy'],

		mounted() {
			this.onqudao();
			if(this.$route.query && this.$route.query.active == 'nolist') {
				this.active = 'nolist';
				this.ononlist(2);
			} else {
				this.onlist();
				this.ononlist(1);
			}
			
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect;
					var num = Number(cr.height) + 30;
					this.$refs.tablediv.style.height = "calc(100% - " + num + "px)";
				}
			});
			this.resizeObserver.observe(this.$refs.filter);
		},

		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
		},

		methods: {
			handleClick() {
				this.page = 1;
				this.onuplist();
			},

			handleCurrentChange(val) {
				this.page = val;
				this.selectionArr = "";
				this.onuplist();
			},
			
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onuplist();
			},

			handleCurrentChange1(val) {
				this.page1 = val;
				this.oncprice(this.checkdata.product_id);
			},

			onfilter() {
				this.page = 1;
				this.onuplist();
			},

			onreset() {
				this.page = 1;
				this.formfilter = {
					shop_id: "",
					brand: "",
					cid: "",
					season: "",
					style_number: "",
					security: ""
				};
				this.onuplist();
			},

			onqudao() {
				var obj = {
					code: "",
					name: "",
					state: 2,
					page: 1,
					limit: 99999
				};

				this.$axios.post('api/user/shop_list', obj).then(res => {
					if (res.data.code == 0) {
						this.qudao = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			handleSelectionChange(val) {
				this.selectionArr = val;
			},

			onlist() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.page = this.page;
				obj.limit = this.pageSize;
				this.$axios.post('api/user/shop_discount_list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
						this.p = res.data.data.total;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			ononlist(val) {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.page = this.page;
				obj.limit = this.pageSize;
				this.$axios.post('api/user/shop_no_discount_list', obj).then(res => {
					if (res.data.code == 0) {
						if (val == 2) {
							this.total = res.data.data.count;
							this.nolist = res.data.data.list;
							this.nototal = res.data.data.count;
						} else {
							this.nototal = res.data.data.count;
						}
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onuploadbox() {
				this.uploadVisible = true;
			},

			ondownload() {
				var url = "https://oss.zhidayd.com/%E7%9B%B4%E8%BE%BE%E8%BF%90%E5%8A%A8-%E8%BF%9B%E8%B4%A7%E6%8A%98%E6%89%A3%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx";
				window.open(url, '_blank');
			},

			onclose2() {
				this.uploadVisible = false;
				this.uploaddata = {
					file_name: "",
					path: ""
				};
				this.uploadtext = "";
			},

			onreturnUrl(url, res, file) {
				this.uploaddata.file_name = file.name;
				this.uploaddata.path = res.file;
				this.uploadtext = this.uploaddata.file_name;
			},

			onfile() {
				if (!this.uploaddata.path) {
					this.$message.error("请先上传模版");
					return;
				}

				var obj = {
					path: this.uploaddata.path
				}

				this.$axios.post('api/user/shop_discount_import', obj).then(res => {
					if (res.data.code == 0) {
						this.$message.success('上传成功，请前往任务中心-导入列表查看状态');
						this.$parent.oncount();
						this.onuplist(2);
						this.onclose2();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onuplist(val) {
				if (this.active == "list") {
					this.onlist();
					if (val == 2) {
						this.ononlist(1);
					}
				}

				if (this.active == "nolist") {
					this.ononlist(2);
				}
			},

			onprop(v) {
				return "size_" + v.id;
			},

			oncprice(id) {
				var obj = {
					from: 2,
					product_id: id,
					page: this.page1,
					limit: this.pageSize1
				}

				this.$axios.post('api/user/compare_price', obj).then(res => {
					if (res.data.code == 0) {
						this.pricelist = res.data.data.list;
						this.pricesize = res.data.data.sizes;
						this.total1 = res.data.data.count;
						var allCh = res.data.data.all_channels;
						if (allCh && Array.isArray(allCh)) {
							this.onExtractChannels(allCh);
						} else {
							this.availableChannels = [];
						}
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onExtractChannels(allChannels) {
				this.availableChannels = [];
				this.syncChannels = false;
				this.syncChannelIds = [];
				var currentShopId = this.checkdata.shop_id;
				for (var i = 0; i < allChannels.length; i++) {
					var ch = allChannels[i];
					if (ch.shop_id != currentShopId) {
						this.availableChannels.push({
							shop_id: ch.shop_id,
							shop_name: ch.shop_name,
							current_discount: ch.current_discount || '-'
						});
					}
				}
			},

			onmodify(obj) {
				this.dialogVisible = true;
				this.checkdata = obj;
				this.ruleForm.discount = obj.discount;
				this.oncprice(obj.product_id);
			},

			onclose() {
				this.dialogVisible = false;
				this.pricelist = [];
				this.pricesize = [];
				this.checkdata = {};
				this.ruleForm.discount = "";
				this.page1 = 1;
				this.pageSize1 = 10;
				this.total1 = 0;
				this.syncChannels = false;
				this.syncChannelIds = [];
				this.availableChannels = [];
			},

			onsub() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						var obj = {
							discount: this.ruleForm.discount,
							id: this.checkdata.id
						}
						if (this.syncChannels && this.syncChannelIds.length > 0) {
							obj.sync_shop_ids = this.syncChannelIds;
						}
						this.$axios.post('api/user/shop_set_discount', obj).then(res => {
							if (res.data.code == 0) {
								var msg = '提交成功';
								if (this.syncChannels && this.syncChannelIds.length > 0) {
									var synced = (res.data.data && res.data.data.updated_count ? res.data.data.updated_count : 1) - 1;
									if (synced > 0) {
										msg += '，已同步更新 ' + synced + ' 个渠道';
									}
								}
								this.$message.success(msg);
								this.onclose();
								this.onuplist(2);
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			},

			onids() {
				var arr = [];
				this.selectionArr.forEach((v, k) => {
					arr.push(v.id);
				})

				return arr.join(',')
			},

			onexport(val) {
				var url = "";
				if (val == 1) {
					url = "api/user/shop_discount_export"
				}

				if (val == 2) {
					url = "api/user/shop_no_discount_export"
				}

				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.ids = this.onids();

				this.$axios.post(url, obj).then(res => {
					if (res.data.code == 0) {
						this.$message.success('请前往任务中心-导出列表下载');
						this.$parent.oncount();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onallsecurity() {
				this.securityVisible = true;
			},

			onclose3() {
				this.securityVisible = false;
				this.securityForm.security = "";
			},

			onsubsecurity() {
				this.$refs['securityForm'].validate((valid) => {
					if (valid) {
						var obj = {
							security: this.securityForm.security,
							ids: this.onids()
						}
						this.$axios.post('api/user/shop_set_security', obj).then(res => {
							if (res.data.code == 0) {
								this.$message.success('提交成功');
								this.onclose3();
								this.selectionArr = [];
								this.onuplist();
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			},

			onallclear() {
				if (this.selectionArr && this.selectionArr.length == 0) {
					this.$message.warning('请先勾选您要操作的数据');
					return;
				}
				this.$confirm('是否清空选中的' + this.selectionArr.length + '条数据的库存', '是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var data = {
						ids: this.onids(),
					}
					this.$axios.post('api/user/shop_stock_clear', data).then(res => {
						if (res.data.code == 0) {
							this.$message.success('成功清除库存');
							this.onuplist();
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				})
			},

			ondelete(id, n) {
				if (n == 2) {
					if (this.selectionArr && this.selectionArr.length == 0) {
						this.$message.warning('请先勾选您要操作的数据');
						return;
					}
				}
				var ids = "";
				var text = "";
				if (id) {
					ids = id;
					text = "是否删除该条数据折扣, 是否继续?";
				} else {
					ids = this.onids();
					text = '是否删除选中的' + this.selectionArr.length + '条数据的折扣';
				}
				this.$confirm(text, '是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var data = {
						ids: ids,
					}
					this.$axios.post('api/user/shop_discount_clear', data).then(res => {
						if (res.data.code == 0) {
							this.$message.success('成功删除折扣');
							this.onuplist(2);
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				})
			},

			cellClassName({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				var num = 0;
				if (this.pricesize) {
					num = this.pricesize.length;
				}

				if (columnIndex == (num + 5)) {
					if (row.allocation_rate >= 86) {
						return "green"
					} else {
						return 'red'
					}
				}


				if (columnIndex == (num + 6)) {
					if (row.free_return_rate) {
						if (row.free_return_rate.split(" + ")[0]) {
							if (row.free_return_rate.split(" + ")[0] == '100%') {
								return "green"
							} else {
								return 'red'
							}
						}
					}
				}

				if (columnIndex == (num + 7)) {
					if (row.on_time_rate >= 86) {
						return "green"
					} else {
						return 'red'
					}
				}
			},

			onsecurity(n) {
				if (n == 1) {
					return ''
				}

				if (n == 2) {
					return '撕防伪'
				}

				if (n == 3) {
					return '不撕防伪'
				}
			},
			
			handleCurrentChange2(id) {
				this.ongdd(id);
			},
			
			handleSizeChange2(val,id) {
				this.page2 = 1;
				this.pageSize2 = val;
				this.ongdd(id);
			},

			ongdd(id) {
				var obj = {};
				obj.shop_id = id;
				obj.page = this.page2;
				obj.limit = this.pageSize2;
				this.$axios.post('api/user/user_shop_notice_list', obj).then(res => {
					if (res.data.code == 0) {
						this.glist = res.data.data.list;
						this.total2 = res.data.data.count;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			onhide() {
				this.glist = [];
				this.page2 = 1;
				this.pageSize2 = 20;
				this.total2 = 0;
			},
			
			oncontent(id,sid){
				var obj = {
					shop_id: sid,
					id: id
				};
				this.$axios.post('api/user/user_shop_notice_list', obj).then(res => {
					if (res.data.code == 0) {
						this.checkobj = res.data.data.list[0];
						this.show = true;
						this.$axios.post('api/user/add_user_notice_view_num?id='+id);
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			onclose4() {
				this.checkobj = {};
				this.show = false;
			},
			
			ondelshopAll() {
				var name = "";
				this.qudao.forEach((v,k)=>{
					if(v.id == this.formfilter.shop_id) {
						name = v.name
					}
				});
				this.$confirm('是否删除' + name + '渠道下的全部折扣', '是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var data = {
						shop_id: this.formfilter.shop_id,
					}
					this.$axios.post('api/user/shop_discount_clear', data).then(res => {
						if (res.data.code == 0) {
							this.$message.success('折扣删除成功');
							this.onuplist();
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				})
				
				
			},
			
			onadd() {
				this.show1 = true;
			},
			
			onclose5() {
				this.show1 = false;
				this.addForm = {
					shop_id: "",
					style_number: "",
					discount: ""
				};
			},
			
			onsubadd() {
				this.$refs['addForm'].validate((valid) => {
					if (valid) {
						var obj = JSON.parse(JSON.stringify(this.addForm));
						this.$axios.post('api/user/shop_set_discount', obj).then(res => {
							if (res.data.code == 0) {
								this.$message.success('提交成功');
								this.onclose5();
								this.onuplist();
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.discount {
		height: 100%;
	}

	.tablebox {
		height: calc(100% - 159px);
	}

	/deep/ .el-tabs {
		padding-left: 20px;
	}

	.i1 {
		font-size: 16px;
		font-weight: bold;
		color: #F65730;
	}

	.img {
		width: 100px;
		height: 100px;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.ftitle {
		width: 100%;
		box-sizing: border-box;
		display: flex;
		margin: 20px 0;

		div {
			margin-right: 6px;
		}

		span {
			color: #F65730;
		}
	}

	.ftable {
		width: 100%;
	}

	.ftop {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.imgform {
		display: flex;
		align-items: center;

		.img {
			margin-right: 20px;
		}

		/deep/ .el-form-item {
			margin-bottom: 0;
		}
	}

	.simg {
		width: 16px;
		height: 16px;
	}

	/deep/ .green {
		color: green !important;
	}

	/deep/ .red {
		color: red !important;
	}

	.is {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 6px;

		img {
			width: 24px;
			height: 24px;
			cursor: pointer;
			margin: 0 5px;
		}

		i {
			font-size: 20px;
			cursor: pointer;
			margin: 0 5px;
		}
	}

	.ggbox {
		width: 100%;
		height: 350px;
	}

	.ggt {
		width: 100%;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		cursor: pointer;
	}
	
	.notice {
		.h1 {
			width: 100%;
			font-size: 20px;
			text-align: center;
			font-weight: bold;
			color: #303133;
		}
		
		.time {
			width: 100%;
			font-size: 14px;
			text-align: center;
			color: #666;
			margin-top: 12px;
		}
	}
	
	.fitem {
		/deep/ .el-input {
			width: 400px !important;
		}
	}
	
	.p {
		font-size: 14px;
		margin-bottom: 10px;
		span {
			color: #F65730;
			margin-right: 12px;
			margin-left: 4px;
		}
	}

	.sync-channels {
		margin-top: 10px;
		padding: 10px 12px;
		background: #f0f9eb;
		border: 1px solid #e1f3d8;
		border-radius: 4px;

		.sync-channel-list {
			margin-top: 8px;
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			gap: 8px 16px;
			max-height: 120px;
			overflow-y: auto;

			/deep/ .el-checkbox {
				margin-right: 0;
			}

			.ch-discount {
				color: #909399;
				font-size: 12px;
			}
		}

		.sync-tip-line {
			margin-top: 4px;

			.sync-tip {
				color: #909399;
				font-size: 12px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/seller/discount.vue